<template>
  <SanInstantSearch
    :search-client="searchClient"
    :index-name="INDEX_NAME"
    :future="{
      preserveSharedStateOnUnmount: true,
      persistHierarchicalRootCount: true
    }"
    :on-state-change="onStateChange"
    :routing="routing"
  >
    <template #default>
      <SanSearchBox :value="$route.query?.query" />

      <SanStats />

      <SanInfiniteHits>
        <template
          #default="{
            items,
            refinePrevious,
            refineNext,
            isLastPage,
            sendEvent,
          }"
        >
          <ul>
            <li>
              <button @click="refinePrevious">
                Show previous results
              </button>
            </li>
            <li
              v-for="item in items"
              :key="item.objectID"
            >
              <h1>
                <ais-highlight
                  :hit="item"
                  attribute="name"
                />
              </h1>
              <p>
                <ais-highlight
                  :hit="item"
                  attribute="active_substances"
                />
              </p>
              <button
                type="button"
                @click="sendEvent('click', item, 'Item Added')"
              >
                Add to cart
              </button>
            </li>
            <li v-if="!isLastPage">
              <button @click="refineNext">
                Show more results
              </button>
            </li>
          </ul>
        </template>
      </SanInfiniteHits>

      <ais-query-rule-custom-data />
    </template>
  </SanInstantSearch>
</template>

<script setup>
import { inject } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { debounce } from 'quasar'
// import { Mah } from '@/models'
import Typesense from 'typesense-instantsearch-adapter'
import SanInstantSearch from '@/components/instant-search/SanInstantSearch.vue'
import SanInfiniteHits from '@/components/instant-search/SanInfiniteHits.vue'
import SanStats from '@/components/instant-search/SanStats.vue'
import SanSearchBox from '@/components/instant-search/SanSearchBox.vue'

const $typesenseDefaultConfig = inject('$typesenseDefaultConfig')
const $route = useRoute()
const $router = useRouter()
const INDEX_NAME = 'brand_index'

const additionalSearchParameters = {
  query_by: 'name,active_substances,mah_name',
  highlight_fields: 'name,active_substances,mah_name'
}
const searchClient = new Typesense({ ...$typesenseDefaultConfig, additionalSearchParameters }).searchClient

const onStateChange = ({ uiState, setUiState }) => {
  const { [INDEX_NAME]: { query } } = uiState
  if (!query || query.length < 2) {
    setUiState({ [INDEX_NAME]: { query: '' } }) // no search if less than 2 character
  } else {
    setUiState(uiState)
  }
}

const queryHook = (query, refine) => { // eslint-disable-line
  return debounce(refine, 500)(query)
}

// const mahs = computed(() => Mah.all()) // eslint-disable-line

const routing = {
  router: {
    read: () => $route.query,
    write: query => $router.push({ query }),
    createURL: query => $route.fullPath,
    onUpdate: cb => {
      routing.router._onPopState = () => cb(routing.router.read())
      window.addEventListener('popstate', routing.router._onPopState)
    },
    dispose () {
      window.removeEventListener('popstate', this._onPopState)
      this.write()
    }
  },
  stateMapping: {
    stateToRoute: uiState => ({
      query: uiState[INDEX_NAME].query,
      // brands:
      //         uiState[INDEX_NAME].refinementList
      //         && uiState[INDEX_NAME].refinementList.brand
      //         && uiState[INDEX_NAME].refinementList.brand.join('~'),
      page: uiState[INDEX_NAME].page
    }),
    routeToState: routeState => {
      return !routeState
        ? {}
        : {
            [INDEX_NAME]: {
              query: routeState.query,
              // refinementList: {
              //   brand: routeState.brands && routeState.brands.split('~')
              // },
              page: routeState.page
            }
          }
    }
  }
}
</script>

<style lang="scss">
.ais-Hits-list {
  margin: 0;
  margin-top: 32px;
  gap: 16px;
}
.ais-Hits-item {
  border: none;
  box-shadow: none;
  margin: 0;
  padding: 0;
}
.ais-Highlight-highlighted {
  background: transparent;
  color: var(--q-primary-mid);
}
</style>
